import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'presDate'
})
export class PresDatePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    switch(value){
      case '2025-11-12':return 'Miércoles';
      case '2025-11-13':return 'Jueves';
      case '2025-11-14':return 'Viernes';
      default:return 'Invalid Date';
    }
    return null;
  }

}
